import createTheme from "@mui/material/styles/createTheme";

export const themeOptions = {
	palette: {
		primary: {
			main: "#0c1726",
			dark: "#1b3456"
		},
		secondary: {
			main: "#20e0c9"
		}
	},
	typography: {
		h1: {
			fontSize: "2rem",
			marginBottom: "0.5rem"
		},
		h2: {
			fontSize: "1.6rem",
			marginTop: "1rem"
		},
		h3: {
			fontSize: "1.2rem",
			marginTop: "0.5rem"
		}
	}
};

export default createTheme(themeOptions);
